"use client";

// Dismissible Top-Banner für DANEXiS DAYS 2027.
// Sitzt über der Nav (z-[60]). Wird beim Schliessen in localStorage gemerkt.
// Höhe synchron halten mit Nav `top` und Body `padding-top` in globals/layout.

import { useEffect, useState } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "danexis-days-2027-banner-dismissed";
const EVENT_URL = "https://www.danexis.com/events/save-the-date-danexis-days-2027/";

export function SaveTheDateBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Erst nach Mount lesen (verhindert Hydration-Mismatch)
    const dismissed = typeof window !== "undefined" && localStorage.getItem(STORAGE_KEY) === "1";
    setVisible(!dismissed);
  }, []);

  useEffect(() => {
    // Banner-Höhe als CSS-Variable exponieren, damit Nav & Content sich verschieben
    document.documentElement.style.setProperty("--banner-h", visible ? "40px" : "0px");
  }, [visible]);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] h-10 bg-[#E86A2C] text-white flex items-center justify-center px-4 text-[13px]"
      role="region"
      aria-label="Event-Ankündigung"
    >
      <a
        href={EVENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 hover:text-[var(--color-blue-light,#8fb8ff)] transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white rounded-sm"
      >
        <span className="font-medium tracking-wide uppercase text-[11px] opacity-70">Save the Date</span>
        <span className="hidden sm:inline opacity-30">·</span>
        <span className="font-medium">DANEXiS DAYS 2027</span>
        <span className="opacity-60 hidden sm:inline">· 27.01.2027</span>
        <span className="opacity-80">→</span>
      </a>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Banner schliessen"
        className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
      >
        <X size={14} strokeWidth={1.75} />
      </button>
    </div>
  );
}
